export default __webpack_public_path__ + "static/media/vegW1.c8341d1e.png";